// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1WR36","modalForm":"UpgradeEpcsModal_modalForm__1mOqB","modalFooter":"UpgradeEpcsModal_modalFooter__1L2Lg"};